import { Box } from "@chakra-ui/react/box";
import { Circle } from "@chakra-ui/react/circle";
import { Float } from "@chakra-ui/react/float";
import { Link } from "@chakra-ui/react/link";

import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useAppSelector } from "redux/hooks";

interface FooterNavLinkProps {
  children: ReactNode;
  hasNotifications?: boolean;
  to: string;
}

const FooterNavLink = ({
  children,
  to,
  hasNotifications = false,
}: FooterNavLinkProps) => {
  const { colorScheme } = useAppSelector((state) => state.theme);
  return (
    <Link
      asChild={true}
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="relative"
      _currentPage={{
        "& svg": {
          color: `${colorScheme}.400`,
        },
      }}
    >
      <NavLink to={to}>
        {children}
        {hasNotifications ? (
          <Float>
            <Circle zIndex="1" height="1rem" width="1rem" bgColor="red.solid" />
          </Float>
        ) : null}
      </NavLink>
    </Link>
  );
};

export default FooterNavLink;
